import { render, staticRenderFns } from "./winningRecord.vue?vue&type=template&id=50d0fe18&scoped=true&"
import script from "./winningRecord.vue?vue&type=script&lang=js&"
export * from "./winningRecord.vue?vue&type=script&lang=js&"
import style0 from "./winningRecord.vue?vue&type=style&index=0&id=50d0fe18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d0fe18",
  null
  
)

export default component.exports